import { createSelector } from 'reselect';

export const getCards = state => state.cards || {};

const getOrderThumbnailSrcFromProject = project => (
  (project
    && project.primaryCustomization
    && project.primaryCustomization.catalog_item_view
    && project.primaryCustomization.catalog_item_view.image_urls
    && project.primaryCustomization.catalog_item_view.image_urls.plp_front) || ''
);

const getDraftThumbnailSrc = project => (
  (project
    && project.primaryCustomization
    && project.primaryCustomization.catalog_item_view
    && project.primaryCustomization.catalog_item_view.image_urls
    && project.primaryCustomization.catalog_item_view.image_urls.plp_front) || ''
);

const getMostRecentDraft = drafts => (
  drafts.reduce((mostRecentDraft, draft) => {
    if (!mostRecentDraft
        || (draft
          && draft.primaryCustomization
          && draft.primaryCustomization.edited_at > mostRecentDraft.primaryCustomization.edited_at)) {
      return draft;
    }
    return mostRecentDraft;
  }, null)
);

const getMostRecentOrder = orders => (
  orders.reduce((mostRecentOrder, order) => {
    if (!mostRecentOrder || order.createdAt > mostRecentOrder.createdAt) {
      return order;
    }
    return mostRecentOrder;
  }, null)
);


export const getInvitesCardState = createSelector(
  getCards,
  (cards) => {
    const drafts = cards
      && cards.cardProject
      && cards.cardProject.drafts
      && cards.cardProject.drafts.drafts
      && cards.cardProject.drafts.drafts.filter(draft => draft.primaryCustomization && draft.primaryCustomization.type === 'INVITATION');
    const orders = cards
      && cards.cardProject
      && cards.cardProject.orders
      && cards.cardProject.orders.filter(order => (order
        && order.projects
        && order.projects.some(project => project.primaryCustomization && project.primaryCustomization.type === 'INVITATION')));
    const hasOrdered = (orders && orders.length > 0) || false;
    let activated = false;
    let draftCount = 0;
    let designName = '';
    let thumbnailSrc = '';

    if (drafts && drafts.length > 0) {
      draftCount = drafts.length;
      const recentDraft = getMostRecentDraft(drafts);
      thumbnailSrc = getDraftThumbnailSrc(recentDraft);
    }

    if (orders.length > 0 || drafts.length > 0) {
      activated = true;
    }

    if (hasOrdered) {
      const recentOrder = getMostRecentOrder(orders);
      const recentProject = recentOrder
        && recentOrder.projects
        && recentOrder.projects.length > 0
        && recentOrder.projects[0];

      designName = recentProject.projectName;
      thumbnailSrc = getOrderThumbnailSrcFromProject(recentProject);

      if (designName && designName.indexOf('Paper Invitation - ') > -1) {
        designName = designName.slice('Paper Invitation - '.length, designName.length);
      }
    }


    return {
      activated,
      draftCount,
      hasOrdered,
      designName,
      thumbnailSrc,
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/dashboard/InvitesCard.js